import { faChevronDown, faExternalLinkAlt, faPortrait, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState, Fragment, useRef, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Button,
  Col,
  Input,
  InputGroup,
  Row,
  FormGroup,
  Label,
  InputGroupText,
  Popover,
  PopoverHeader,
  PopoverBody,
  UncontrolledPopover,
} from 'reactstrap';
import SyntheticEvaluation from './SyntheticEvaluation/SyntheticEvaluation.js';
import { useAuth0 } from '../../../../auth0/reactAuth0Spa';
import {
  formatBearerToken,
  userExistsInSystem,
  getDefaultInterviewDate,
  checkLoginForError,
} from '../../../../Common.functions';
import { DepartmentContext } from '../../../../DepartmentWrapper';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { fetchData, fetchDataAgnostic, postDataAgnostic } from '../../../../Services/dataApi';
import { clone } from '../../../../Services/schedule';
import {
  getInterviewDatePk,
  isPrescreenInterviewDate,
  normalizeInterviewDate,
  PRESCREEN_INTERVIEW_DATE,
} from '../../../../Services/interviewDate';
import AddUser from '../AdminTeam/AddUser/AddUser';
import style from './AdminEvaluate.style';
import './AdminEvaluate.style.css';
import { popoverModifiers } from 'enums.js';

// Initialize Day.js plugins
dayjs.extend(isSameOrBefore);

const radioButtonOptions = {
  showAllUsers: 'showAllUsers',
  showScheduledUsers: 'showScheduledUsers',
};

const AdminEvaluate = ({ date = {}, setDate, location, popoutOnly = false }) => {
  const [users, setUsers] = useState([]);
  const [usersWithPrescreenAssignments, setUsersWithPrescreenAssignments] = useState([]);
  const [dateArray, setDateArray] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  const [selectedUser, setSelectedUser] = useState(null);
  const [searchString, setSearchString] = useState('');
  const [showAllUsers, setShowAllUsers] = useState(false);
  const [showEvaluatorSelector, setShowEvaluatorSelector] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [emailThatExists, setEmailThatExists] = useState('');
  const [genericUserCreationError, setGenericUserCreationError] = useState(false);
  const [myDate, setMyDate] = useState({});
  const [adjacentDates, setAdjacentDates] = useState([]);
  const [closestDates, setClosestDates] = useState([]);

  const [isFetchingUsers, setIsFetchingUsers] = useState(false);
  const [isFetchingUsersWithCandidates, setIsFetchingUsersWithCandidates] = useState(false);
  const [allowPrescreen, setAllowPrescreen] = useState(false);
  const [enablePrescreenMode, setEnablePrescreenMode] = useState();
  const [test, setTest] = useState('test beginning');

  const [showAddUser, setShowAddUser] = useState();
  const [isPosting, setIsPosting] = useState(false);
  const [user, setUser] = useState({});
  const [URLUser, setURLUser] = useState(null);

  const [pendingQueryInterviewDate, setPendingQueryInterviewDate] = useState(null);
  const [pendingQueryUser, setPendingQueryUser] = useState(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  const [loading, setLoading] = useState(true);

  const dContext = useContext(DepartmentContext);
  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const routerLocation = useLocation();
  const query = new URLSearchParams(routerLocation.search || window.location.search);
  const history = useHistory();
  const selectedRef = useRef(null);
  const clearEvaluatorOnNextFetchRef = useRef(true);
  const isPopoutMode = popoutOnly || (location && location.pathname && location.pathname.includes('/evaluate/popout'));
  const departmentPk = dContext && dContext.department ? dContext.department.pk_Department : null;
  const seasonPk = dContext && dContext.season ? dContext.season.pk_Season : null;

  const onRefChange = useCallback(
    (node) => {
      // if the user is coming from another page with a pre-selection we need to make sure to scroll down to the apporpirate selection.
      // We should only do this once on mount
      if (node !== null && !hasScrolled) {
        node.scrollIntoView();
        setHasScrolled(true);
      }
    },
    [hasScrolled],
  );
  const clearConsumedSelectionQueryParams = useCallback(
    (paramsToClear = ['pk_InterviewDate', 'pk_User']) => {
      const currentQuery = new URLSearchParams(routerLocation.search || window.location.search);
      let didChange = false;

      paramsToClear.forEach((param) => {
        if (currentQuery.has(param)) {
          currentQuery.delete(param);
          didChange = true;
        }
      });

      if (!didChange) {
        return;
      }

      const nextSearch = currentQuery.toString();
      const nextUrl = `${routerLocation.pathname}${nextSearch ? `?${nextSearch}` : ''}`;

      if (window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', nextUrl);
      }

      history.replace(nextUrl);
    },
    [history, routerLocation.pathname, routerLocation.search],
  );

  useEffect(() => {
    setPendingQueryInterviewDate(query.get('pk_InterviewDate'));
    setPendingQueryUser(query.get('pk_User'));
  }, [routerLocation.search]);

  useEffect(() => {
    if (dContext && dContext.season) {
      setAllowPrescreen(dContext.season.AllowPrescreen);
      setEnablePrescreenMode(dContext.season.EnablePrescreenMode);
    }
  }, [dContext]);

  useEffect(() => {

    if (!dContext || !dContext.season || enablePrescreenMode == null || !Array.isArray(dateArray)) {
      return;
    }

    let nextDate = null;

    if (pendingQueryInterviewDate != null) {
      if (!isPrescreenInterviewDate(pendingQueryInterviewDate) && dateArray.length === 0) {
        return;
      }

      nextDate = normalizeInterviewDate(pendingQueryInterviewDate, dateArray);
      const hasConcreteInterviewDate =
        nextDate && (isPrescreenInterviewDate(nextDate) || (nextDate.DateOfInterview && nextDate.StartTime));

      if (!hasConcreteInterviewDate && dateArray.length > 0) {
        nextDate = enablePrescreenMode
          ? PRESCREEN_INTERVIEW_DATE
          : normalizeInterviewDate(getDefaultInterviewDate(dateArray, dContext.season), dateArray);
      }

      setPendingQueryInterviewDate(null);
    } else if (!getInterviewDatePk(myDate)) {
      if (enablePrescreenMode) {
        nextDate = PRESCREEN_INTERVIEW_DATE;
      } else if (dateArray.length > 0) {
        nextDate = normalizeInterviewDate(getDefaultInterviewDate(dateArray, dContext.season), dateArray);
      }
    }

    if (nextDate && getInterviewDatePk(nextDate) !== getInterviewDatePk(myDate)) {
      setMyDate(nextDate);
    }

    setLoading(false);
  }, [dateArray, enablePrescreenMode, pendingQueryInterviewDate, myDate, dContext, dContext.season]);

  useEffect(() => {
    const normalizedDate = normalizeInterviewDate(myDate, dateArray);

    if (normalizedDate && !isPrescreenInterviewDate(normalizedDate)) {
      getAdjacentSchedule(dateArray || [], normalizedDate);
    } else {
      setAdjacentDates([]);
    }
  }, [myDate, dateArray]);

  useEffect(() => {
    const normalizedDate = normalizeInterviewDate(myDate, dateArray);

    if (!normalizedDate || !getInterviewDatePk(normalizedDate)) {
      return;
    }

    setDate(normalizedDate);
    getUsers(normalizedDate);

    if (isPrescreenInterviewDate(normalizedDate)) {
      getEvaluatorsWithAssignedCandidates();
    } else if (usersWithPrescreenAssignments.length > 0) {
      setUsersWithPrescreenAssignments([]);
    }
  }, [myDate, showAllUsers, dateArray]);

  useEffect(() => {
    filterBySearch(searchString);
  }, [searchString, users]);

  useEffect(() => {
    if (!pendingQueryUser || !users || users.length === 0) {
      return;
    }

    const userToSelect = users.find((user) => String(user.pk_User) === String(pendingQueryUser));
    if (userToSelect && (!selectedUser || selectedUser.pk_User !== userToSelect.pk_User)) {
      setSelectedUser(userToSelect);
      setPendingQueryUser(null);
      clearConsumedSelectionQueryParams();
    }
  }, [users, pendingQueryUser, selectedUser, clearConsumedSelectionQueryParams]);

  useEffect(() => {
    const queryInterviewDate = query.get('pk_InterviewDate');
    const queryUser = query.get('pk_User');
    const hasBootstrapQuery = queryInterviewDate != null || queryUser != null;
    const selectedDatePk = getInterviewDatePk(myDate);
    const hasConsumedDate =
      !queryInterviewDate || (selectedDatePk != null && String(selectedDatePk) === String(queryInterviewDate));
    const hasConsumedUser = !queryUser || (selectedUser && String(selectedUser.pk_User) === String(queryUser));

    if (!hasBootstrapQuery || pendingQueryInterviewDate != null || pendingQueryUser != null) {
      return;
    }

    if (hasConsumedDate && hasConsumedUser) {
      clearConsumedSelectionQueryParams();
    }
  }, [
    routerLocation.search,
    query,
    myDate,
    selectedUser,
    pendingQueryInterviewDate,
    pendingQueryUser,
    clearConsumedSelectionQueryParams,
  ]);

  useEffect(() => {
    if (!departmentPk || !seasonPk) {
      return;
    }

    setLoading(true);
    getSeason();
    getActiveInterviewDates();
  }, [departmentPk, seasonPk]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      setIsMobile(window.innerWidth < 1100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isFetchingUsers && !isFetchingUsersWithCandidates && isPrescreenInterviewDate(myDate)) {
      const newUsers = [];
      usersWithPrescreenAssignments.forEach((user) => {
        const counterpart = users.find((u) => {
          return u.pk_User === user.pk_User;
        });
        if (counterpart && counterpart.EnableEvaluator && !counterpart.Deleted) {
          newUsers.push(counterpart);
        }
      });

      if (JSON.stringify(users) !== JSON.stringify(newUsers)) {
        setUsers(newUsers);
      }
    }
  }, [users, usersWithPrescreenAssignments]);

  const getActiveInterviewDates = (callback) => {
    getTokenSilently()
      .then((t) => {
        fetchDataAgnostic(
          'department/interviewDates',
          // 'department/season/user/scheduledates',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            // isAdmin: myDate === 'Prescreen' ? 1 : null,
            // pk_User: myDate === 'Prescreen' && selectedUser ? selectedUser.pk_User : null,
          },

          formatBearerToken(t),
        )
          .then((res) => {
            const datesSortedByEarliest = res.data.sort((a, b) => {
              const firstMillis = dayjs(`${a.DateOfInterview} ${a.StartTime}`).valueOf();
              const secondMillis = dayjs(`${b.DateOfInterview} ${b.StartTime}`).valueOf();

              if (firstMillis < secondMillis) {
                return -1;
              }
              if (firstMillis > secondMillis) {
                return 1;
              }
              // a must be equal to b
              return 0;
            });

            const scheduleLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
            let placeholderLabelCount = 0;
            let oldDate = null;
            datesSortedByEarliest.forEach((d) => {
              if (oldDate != d.DateOfInterview) {
                placeholderLabelCount = 0;
                oldDate = d.DateOfInterview;
              }
              if (!d.Label) {
                if (placeholderLabelCount < scheduleLetters.length) {
                  d.Label = `Schedule ${scheduleLetters[placeholderLabelCount]}`;
                } else {
                  d.Label = `Schedule ${placeholderLabelCount - scheduleLetters.length}`;
                }
              }
              placeholderLabelCount++;
            });
            setDateArray(datesSortedByEarliest);
            if (callback) {
              callback();
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const handleChange = (key, value) => {
    const newUser = clone(user);
    newUser[key] = value;
    setUser(newUser);
  };

  const filterBySearch = (str) => {
    const newFiltered = users.filter((user) => {
      const name = `${user.UserFirst} ${user.UserLast}`;
      return str == '' || !str || name.toLowerCase().indexOf(str.toLowerCase()) >= 0;
    });

    setFilteredUsers((prevData) => {
      const newSelectedUser = newFiltered.find((user) => {
        return selectedUser && user.pk_User == selectedUser.pk_User;
      });
      setSelectedUser(newSelectedUser);

      return newFiltered;
    });
  };

  // Get evalautors with assigned candidates for prescreen
  const getEvaluatorsWithAssignedCandidates = () => {
    setIsFetchingUsersWithCandidates(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/users/prescreen/all',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsFetchingUsersWithCandidates(false);
            const rawUsers = Object.values(res.data)
              // .filter((user) => {
              //   return !user.Deleted && user.EnableEvaluator;
              // })
              .sort((a, b) => {
                const textA = `${a.UserLast ? `${a.UserLast}, ` : ''}${a.UserFirst || ''}`.toUpperCase();
                const textB = `${b.UserLast ? `${b.UserLast}, ` : ''} ${b.UserFirst}`.toUpperCase();

                return textA < textB ? -1 : textA > textB ? 1 : 0;
              });
            setUsersWithPrescreenAssignments(rawUsers);
          })
          .catch((err) => {
            console.error('Error getting evaluators with assigned candidates', err);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getUsers = (selectedDate = myDate) => {
    const normalizedDate = normalizeInterviewDate(selectedDate, dateArray);
    const isPrescreen = isPrescreenInterviewDate(normalizedDate);
    const payload = {
      pk_Department: dContext.department.pk_Department,
      pk_Season: isPrescreen ? dContext.season.pk_Season : null,
      pk_InterviewDate: showAllUsers || isPrescreen ? null : getInterviewDatePk(normalizedDate),
      mode: isPrescreen ? 'Prescreen' : 'Evaluation',
    };

    setIsFetchingUsers(true);
    getTokenSilently()
      .then((token) => {
        return fetchDataAgnostic('department/users', payload, formatBearerToken(token))
          .then((res) => {
            if (clearEvaluatorOnNextFetchRef.current && !isPopoutMode) {
              setSelectedUser(null);
            }
            clearEvaluatorOnNextFetchRef.current = true;

            setIsFetchingUsers(false);
            const rawUsers = Object.values(res.data)
              .filter((user) => {
                return !user.Deleted && user.EnableEvaluator;
              })
              .sort((a, b) => {
                const textA = `${a.UserLast ? `${a.UserLast}, ` : ''}${a.UserFirst || ''}`.toUpperCase();
                const textB = `${b.UserLast ? `${b.UserLast}, ` : ''} ${b.UserFirst}`.toUpperCase();

                return textA < textB ? -1 : textA > textB ? 1 : 0;
              });
            setUsers(rawUsers);

            let userToSelect = null;

            if (pendingQueryUser != null) {
              userToSelect =
                rawUsers.find((user) => {
                  return String(user.pk_User) === String(pendingQueryUser);
                }) || null;

              if (userToSelect) {
                setPendingQueryUser(null);
                clearConsumedSelectionQueryParams();
              }
            } else if (selectedUser && selectedUser.pk_User != null) {
              userToSelect =
                rawUsers.find((user) => {
                  return user.pk_User == selectedUser.pk_User;
                }) || null;
            }

            if (userToSelect) {
              setSelectedUser(userToSelect);
            }
          })
          .catch((err) => {
            setIsFetchingUsers(false);
            clearEvaluatorOnNextFetchRef.current = true;
            const rawUsers = users.slice();
            if (selectedUser) {
              const userToSelect = rawUsers.find((user) => {
                return user.pk_User == selectedUser.pk_User;
              });
              // setSelectedUser(userToSelect || rawUsers[0]);
            } else {
              // setSelectedUser(rawUsers[0]);
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getSeason = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            if (res.data) {
              setAllowPrescreen(res.data.AllowPrescreen);
              setEnablePrescreenMode(res.data.EnablePrescreenMode);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const handleDateChange = (e) => {
    clearEvaluatorOnNextFetchRef.current = e && e.clearEvaluator !== undefined ? e.clearEvaluator : true;
    if (isPrescreenInterviewDate(e.target.value)) {
      setShowAllUsers(false);
      setMyDate(PRESCREEN_INTERVIEW_DATE);

      return;
    } else {
      const selectedDate = normalizeInterviewDate(e.target.value, dateArray);
      if (selectedDate) {
        setMyDate(selectedDate);
      }
    }
  };

  const saveNewUser = (userObject) => {
    userObject.Auth0Email = userObject.UserEmail;
    const users = [userObject];
    setIsPosting(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/users',
          { pk_Department: dContext.department.pk_Department, isSingleUser: true },
          { users },
          formatBearerToken(token),
        )
          .then(async (result) => {
            if (result.data.userExists) {
              setEmailThatExists(users[0].UserEmail);
              toast.error('A user with that email already exists in this department.');
            } else if (result.data.error) {
              setGenericUserCreationError(true);
              toast.error('Something went wrong...');
            } else {
              if (result.data.userExistInSystem) {
                userExistsInSystem(result.data.userObject);
              } else {
                toast.success('User Saved');
              }

              await getUsers();
              setShowAddUser(false);
              setUser({});
              // TODO: Find a better way to get current state
              setUsers((prevState) => {
                const selectedUser = prevState.find((user) => {
                  return result.data.pk_User === user.pk_User;
                });
                setSelectedUser(selectedUser);
                return prevState;
              });
            }
          })
          .catch((err) => {
            setGenericUserCreationError(true);
          })
          .finally(() => {
            setIsPosting(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getClosestDate = (dateArray) => {
    const now = dayjs();
    const datesSortedByEarliest = dateArray.sort((a, b) => {
      const firstMillis = dayjs(`${a.DateOfInterview} ${a.StartTime}`).valueOf();
      const secondMillis = dayjs(`${b.DateOfInterview} ${b.StartTime}`).valueOf();

      if (firstMillis < secondMillis) {
        return -1;
      }
      if (firstMillis > secondMillis) {
        return 1;
      }
      // a must be equal to b
      return 0;
    });

    return datesSortedByEarliest.filter((date) => {
      return now.isSameOrBefore(dayjs(`${date.DateOfInterview} ${date.StartTime}`));
    });
  };

  const getAdjacentSchedule = (dates, currentDate) => {
    const newAdjacentDates =
      dates.filter((d) => {
        return d.DateOfInterview === currentDate.DateOfInterview;
        // && d.pk_InterviewDate != currentDate.pk_InterviewDate;
      }) || [];

    setAdjacentDates(newAdjacentDates);
  };

  const changeEvaluatorScope = (e) => {
    clearEvaluatorOnNextFetchRef.current = false;
    if (e.target.value === radioButtonOptions.showScheduledUsers) {
      setShowAllUsers(false);
    } else if (e.target.value === radioButtonOptions.showAllUsers) {
      setShowAllUsers(true);
    }
    // setShowAllUsers(value);
  };

  const renderUserExistsError = () => {
    if (emailThatExists.trim() !== '') {
      if (user && user.UserEmail === emailThatExists) {
        return true;
      }
    }
    return false;
  };

  if (loading) {
    return <div />;
  }

  const renderDateDropdown = () => {
    const selectedInterviewDate = getInterviewDatePk(myDate) || '';

    if (isMobile) {
      return (
        <div>
          <InputGroup>
            <InputGroupText>Interview Date</InputGroupText>
            <Input
              type="select"
              id="interviewDate"
              name="interviewDate"
              value={selectedInterviewDate}
              onChange={(e) => {
                handleDateChange({ target: { value: e.target.value }, clearEvaluator: false });
              }}
            >
              {allowPrescreen ? <option value={'Prescreen'}>Prescreen</option> : null}
              {dateArray.map((item) => {
                const { DateOfInterview, pk_InterviewDate, Label } = item;
                return (
                  <option key={pk_InterviewDate} value={pk_InterviewDate}>
                    {DateOfInterview ? dayjs(DateOfInterview).format('MMM DD, YYYY (ddd)') : 'No Date'}
                    {`${Label ? `: ${Label}` : ''}`}
                  </option>
                );
              })}
            </Input>
          </InputGroup>
        </div>
      );
    } else {
      return (
        <Fragment>
          <FormGroup>
            <Label for="exampleCustomSelect">Interview Date</Label>
            <Input
              type="select"
              id="exampleCustomSelect"
              name="customSelect"
              value={selectedInterviewDate}
              onChange={(e) => {
                handleDateChange({ target: { value: e.target.value }, clearEvaluator: false });
              }}
            >
              {allowPrescreen ? <option value={'Prescreen'}>Prescreen</option> : null}
              {dateArray.map((item) => {
                const { DateOfInterview, pk_InterviewDate, Label } = item;
                return (
                  <option key={pk_InterviewDate} value={pk_InterviewDate}>
                    {DateOfInterview ? dayjs(DateOfInterview).format('MMM DD, YYYY (ddd)') : 'No Date'}
                    {`${Label ? `: ${Label}` : ''}`}
                  </option>
                );
              })}
            </Input>
          </FormGroup>

          {!isPrescreenInterviewDate(myDate) ? (
            <>
              <FormGroup check style={{ marginRight: '15px', marginBottom: '10px' }}>
                <Label check>
                  <Input
                    checked={!showAllUsers}
                    value={radioButtonOptions.showScheduledUsers}
                    type="radio"
                    name="radio2"
                    onChange={changeEvaluatorScope}
                  />{' '}
                  Scheduled Evaluators
                </Label>
              </FormGroup>
              <FormGroup check style={{ marginBottom: '10px' }}>
                <Label check>
                  <Input
                    checked={showAllUsers}
                    value={radioButtonOptions.showAllUsers}
                    type="radio"
                    name="radio2"
                    onChange={changeEvaluatorScope}
                  />{' '}
                  All Evaluators
                </Label>
              </FormGroup>
            </>
          ) : null}
        </Fragment>
      );
    }
  };

  const renderUserButton = () => {
    const { UserFirst, UserLast } = selectedUser || {};

    return (
      <div style={{ ...style.simpleRow, marginTop: 5 }}>
        <Button id="evaluatorSelectorBtn" outline={selectedUser ? false : true} style={{ width: '100%' }}>
          <div style={{ ...style.simpleRow, width: '100%' }}>
            <div
              style={{
                ...style.simpleColumn,
                width: `calc(100% - 30px)`,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {selectedUser ? `${UserLast || ''}, ${UserFirst || ''}` : 'Select an Evaluator'}
            </div>
            <div style={{ ...style.simpleColumn, width: 30, justifyContent: 'center', alignItems: 'center' }}>
              <FontAwesomeIcon icon={faChevronDown} style={style.buttonIcon} />
            </div>{' '}
          </div>
          {renderEvaluatorSelectorPopover()}
        </Button>
      </div>
    );
  };

  const renderEvaluatorSelectorPopover = () => {
    return (
      <Popover
        isOpen={showEvaluatorSelector}
        target={'evaluatorSelectorBtn'}
        trigger="legacy"
        placementPrefix="evaluatorSelectionButtonDropdown bs-popover"
        style={{ height: 400 }}
        modifiers={popoverModifiers}
        placement="bottom"
        toggle={() => {
          setShowEvaluatorSelector(!showEvaluatorSelector);
        }}
      >
        <PopoverBody style={{ width: '500px', height: 400 }}>
          <div>
            {
              <div style={style.simpleColumn}>
                {renderSearchInput()}
                <div style={{ ...style.simpleRow, marginTop: 5 }}>
                  <div style={{ ...style.simpleColumn, width: '100%', height: 340, overflowY: 'auto' }}>
                    {!isFetchingUsers ? (
                      filteredUsers.length > 0 ? (
                        filteredUsers.map((user, index) => {
                          const {
                            UserPhotoUrl,
                            UserFirst,
                            UserLast,
                            LastLoginDate,
                            Role,
                            EnableEvaluator,
                            Deleted,
                          } = user;
                          let itemProps = {};
                          let backgroundColor = null;
                          if (selectedUser && selectedUser.pk_User == user.pk_User) {
                            itemProps = { ref: onRefChange };
                            backgroundColor = 'var(--rr-primary-soft)';
                          } else if (index % 2 == 0) {
                            backgroundColor = 'var(--rr-surface-stripe)';
                          }

                          if (Deleted || !EnableEvaluator) {
                            // backgroundColor = '#f8d7da';
                          }
                          return (
                            <div
                              style={{ ...style.simpleRow, backgroundColor, cursor: 'pointer' }}
                              {...itemProps}
                              onClick={() => {
                                setSelectedUser(user);
                                setShowEvaluatorSelector(false);
                              }}
                            >
                              <div
                                style={{
                                  ...style.simpleColumn,
                                  width: 40,
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                {UserPhotoUrl ? (
                                  <img src={UserPhotoUrl} height={30} style={{ ...style.imgPlaceHolder, width: 30 }} />
                                ) : (
                                  <FontAwesomeIcon
                                    style={{ ...style.imgPlaceHolder, fontSize: 30 }}
                                    icon={faPortrait}
                                  />
                                )}
                              </div>
                              <div>
                                <div>{`${UserLast}, ${UserFirst}`}</div>
                                <div style={{ fontSize: 12, fontWeight: 'bold', height: !Role ? 20 : null }}>
                                  {Role || ' '}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div style={style.centeredText}>No Users</div>
                      )
                    ) : null}
                  </div>
                </div>
              </div>
            }
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderSearchInput = () => {
    return (
      <InputGroup>
        <Button
          onClick={() => {
            setSearchString('');
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
        <Input
          value={searchString}
          type="text"
          placeholder="Search User. . ."
          onChange={(e) => {
            setSearchString(e.target.value);
          }}
        />
        <Button color="success">
          <FontAwesomeIcon icon={faSearch} />
        </Button>
      </InputGroup>
    );
  };

  const getPopoutInterviewDate = () => {
    if (isPrescreenInterviewDate(myDate)) {
      return 'Prescreen';
    }

    if (getInterviewDatePk(myDate)) {
      return getInterviewDatePk(myDate);
    }

    if (dateArray && dateArray.length > 0) {
      const defaultDate = getDefaultInterviewDate(dateArray, dContext.season);
      if (defaultDate && defaultDate.pk_InterviewDate) {
        return defaultDate.pk_InterviewDate;
      }
    }

    return null;
  };

  const openEvaluatorPopout = (user, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const interviewDateToUse = getPopoutInterviewDate();
    if (!interviewDateToUse) {
      toast.warning('Please select an interview date first.');
      return;
    }

    const pk_Department = dContext && dContext.department ? dContext.department.pk_Department : null;
    const departmentQuery = pk_Department ? `&pk_Department=${pk_Department}` : '';
    const popoutUrl = `/administrator/evaluate/popout?pk_User=${user.pk_User}&pk_InterviewDate=${interviewDateToUse}${departmentQuery}`;
    const popoutWindow = window.open(popoutUrl, '_blank', 'noopener,noreferrer');
    if (popoutWindow && popoutWindow.focus) {
      popoutWindow.focus();
    }
  };

  const renderPopoutHeader = () => {
    const { UserFirst, UserLast } = selectedUser || {};
    const evaluatorName =
      selectedUser && selectedUser.pk_User ? `${UserLast || ''}, ${UserFirst || ''}` : 'Loading Evaluator...';
    const dateText = isPrescreenInterviewDate(myDate)
      ? 'Prescreen'
      : myDate && myDate.MomentDateOfInterview
      ? `${myDate.MomentDateOfInterview.format('MMM D, YYYY')}${myDate.Label ? ` (${myDate.Label})` : ''}`
      : 'Loading Session...';

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 12px',
          borderBottom: '1px solid #d1d5db',
          marginBottom: 8,
          backgroundColor: 'var(--rr-surface-subtle)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: 12, fontWeight: 'bold', color: '#6b7280' }}>Evaluator View</div>
          <div style={{ fontSize: 16, fontWeight: 'bold' }}>{evaluatorName}</div>
          <div style={{ fontSize: 12 }}>{dateText}</div>
        </div>
        <Button
          size="sm"
          color="secondary"
          onClick={() => {
            window.close();
          }}
        >
          Close
        </Button>
      </div>
    );
  };

  const renderUserList = () => {
    return (
      <div style={{ ...style.userListContainer }}>
        {/* <div> {filteredUsers.length}</div> */}
        {!isFetchingUsers ? (
          filteredUsers.length > 0 ? (
            filteredUsers.map((user, index) => {
              const { UserPhotoUrl, UserFirst, UserLast, LastLoginDate, Role, EnableEvaluator, Deleted } = user;
              let itemProps = {};
              let backgroundColor = null;
              if (selectedUser && selectedUser.pk_User == user.pk_User) {
                itemProps = { ref: onRefChange };
                backgroundColor = 'var(--rr-primary-soft)';
              } else if (index % 2 == 0) {
                backgroundColor = 'var(--rr-surface-stripe)';
              }

              if (Deleted || !EnableEvaluator) {
                // backgroundColor = '#f8d7da';
              }
              return (
                <div
                  style={{ ...style.itemRow, backgroundColor }}
                  {...itemProps}
                  onClick={() => {
                    setSelectedUser(user);
                  }}
                >
                  <div
                    style={{
                      minWidth: 50,
                      width: 50,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: 10,
                      flexShrink: 0,
                    }}
                  >
                    {UserPhotoUrl ? (
                      <img src={UserPhotoUrl} height={50} style={{ ...style.imgPlaceHolder, marginRight: 0 }} />
                    ) : (
                      <FontAwesomeIcon style={{ ...style.imgPlaceHolder, marginRight: 0 }} icon={faPortrait} />
                    )}
                  </div>
                  <div style={{ ...style.candidateInfo, flex: 1, minWidth: 0 }}>
                    <div>{`${UserLast}, ${UserFirst}`}</div>
                    <div style={{ fontSize: 12, fontWeight: 'bold', height: !Role ? 20 : null }}>{Role || ' '}</div>
                  </div>
                  <div
                    style={{
                      minWidth: 35,
                      width: 35,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      marginLeft: 10,
                      flexShrink: 0,
                    }}
                  >
                    <Button
                      size="sm"
                      color="secondary"
                      style={{ width: 35, minWidth: 35, paddingLeft: 0, paddingRight: 0 }}
                      title="Open Evaluator Popout"
                      onClick={(e) => {
                        openEvaluatorPopout(user, e);
                      }}
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </Button>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: 'center' }}>No Users</div>
          )
        ) : (
          <div style={{ textAlign: 'center' }}>Loading . . .</div>
        )}
      </div>
    );
  };

  const renderAddUserModal = () => {
    return (
      <AddUser
        isOpen={showAddUser}
        user={user}
        setUser={setUser}
        setIsOpen={setShowAddUser}
        saveNewUser={saveNewUser}
        isPosting={isPosting}
        handleChange={handleChange}
        renderUserExistsError={renderUserExistsError}
      />
    );
  };

  if (isPopoutMode) {
    return (
      <div style={{ height: 'calc(100vh - 120px)', width: '100%' }}>
        {renderPopoutHeader()}
        <div style={{ height: 'calc(100% - 70px)' }}>
          <SyntheticEvaluation
            selectedEvaluator={selectedUser}
            isAdmin={true}
            date={myDate}
            adjacentDates={adjacentDates}
            handleDateChange={handleDateChange}
            dateArray={dateArray}
            isPopout={true}
          />
        </div>
      </div>
    );
  } else if (isMobile) {
    return (
      <div style={{ ...style.simpleRow }}>
        <div style={{ ...style.simpleColumn, width: '100%' }}>
          {renderDateDropdown()}
          {renderUserButton()}
          <div style={{ height: 'calc(100vh - 400px)' }}>
            <SyntheticEvaluation
              selectedEvaluator={selectedUser}
              isAdmin={true}
              date={myDate}
              adjacentDates={adjacentDates}
              handleDateChange={handleDateChange}
              dateArray={dateArray}
              isMobile={isMobile}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 300, width: '25%' }}>
          <Row style={{ padding: 10, marginRight: 2, marginLeft: 5 }} className="card shadow bg-light">
            <Col md={12}>
              <Row>{renderDateDropdown()}</Row>
              <Row>{renderSearchInput()}</Row>
              <Row> {renderUserList()}</Row>
            </Col>
          </Row>
        </div>
        <div
          className="card shadow bg-light"
          style={{ display: 'flex', flexDirection: 'column', width: 'calc(75% - 10px)', minWidth: 0 }}
        >
          <div style={{ padding: 10, marginRight: 2, height: '100%', padding: '10px 5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: 0, width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                <SyntheticEvaluation
                  selectedEvaluator={selectedUser}
                  isAdmin={true}
                  date={myDate}
                  adjacentDates={adjacentDates}
                  handleDateChange={handleDateChange}
                  dateArray={dateArray}
                />
              </div>
              {/* EVALUATE SHEET for {selectedUser && selectedUser.UserFirst ? selectedUser.UserFirst : ''}{' '}
              {selectedUser && selectedUser.UserLast ? selectedUser.UserLast : ''} */}
            </div>
          </div>
        </div>
        {renderAddUserModal()}
      </div>
    );
  }
};

export default AdminEvaluate;
